var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-width-background" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "inner-breadcrumb" }, [
        _vm.collection
          ? _c("p", { staticClass: "breadcrumb-text" }, [
              _c("a", { attrs: { href: "/" } }, [_vm._v("Home")]),
              _c("span", { staticClass: "breadcrumb-text__divider" }, [
                _vm._v("/")
              ]),
              _c(
                "a",
                { attrs: { href: "/collections/" + _vm.collection.handle } },
                [_vm._v(_vm._s(_vm.collection.title))]
              ),
              _c("span", { staticClass: "breadcrumb-text__divider" }, [
                _vm._v("/")
              ]),
              _c("a", [_vm._v(_vm._s(_vm.product.title))])
            ])
          : _c("p", { staticClass: "breadcrumb-text" }, [
              _c("a", { attrs: { href: "/" } }, [_vm._v("Home")]),
              _c("span", { staticClass: "breadcrumb-text__divider" }, [
                _vm._v("/")
              ]),
              _c("a", [_vm._v(_vm._s(_vm.product.title))])
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }